import React from 'react';

import { BrowseHeadline } from 'apps/browse/components/BrowseHeadline';
import { ConditionalPortal } from 'components/utils/ConditionalPortal';

type Props = {
  title: string;
  isModalMode: boolean;
  onRequestClose: () => void;
};

export const BrowseSidebar: React.FC<Props> = ({
  title,
  isModalMode,
  onRequestClose,
  children,
}) => {
  const width = 176;
  const padding = 16;

  return (
    <div
      className='col-auto d-none d-sm-block pr-2'
      style={{ minWidth: width + padding, maxWidth: width + padding }}
    >
      <ConditionalPortal renderOutside={isModalMode} offsetFromTop>
        <div className={isModalMode ? 'container-fluid' : ''}>
          {isModalMode ? (
            <BrowseHeadline title={title} buttonTitle='Done' onClick={onRequestClose} />
          ) : null}
          {children}
        </div>
      </ConditionalPortal>
    </div>
  );
};
